import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Select from '../../shared/reactSelect/select.component';
import TruncatableSelect from '../../shared/reactSelect/truncatableSelect.component';
import { listItemPropTypes } from '../../shared/propTypes';

import {
  detailedCountryTaxTypesDataSelector,
  isFetchingCountryTaxTypesSelector,
} from './store/selectors';
import { DetailedCountryTaxTypesDataPropTypes } from './propTypes';
import ReportingCurrencySelect from './reportingCurrencySelect.component';

class EffectiveTaxRateForm extends PureComponent {
  static propTypes = {
    periodName: PropTypes.string.isRequired,
    allCountryTaxTypes: PropTypes.arrayOf(listItemPropTypes).isRequired,
    selectedCountryTaxTypes: PropTypes.arrayOf(listItemPropTypes).isRequired,
    allStatutoryTaxRates: PropTypes.arrayOf(listItemPropTypes).isRequired,
    statutoryTaxRate: listItemPropTypes,

    selectCountryTaxType: PropTypes.func.isRequired,
    selectStatutoryTaxRate: PropTypes.func.isRequired,
    groupType: PropTypes.string,
    groupItem: PropTypes.string,
    groupBy: PropTypes.string,
    detailedCountryTaxTypesData: DetailedCountryTaxTypesDataPropTypes.isRequired,
    showCurrencyControl: PropTypes.bool,
    fetchReport: PropTypes.func,
    isFetchingCountryTaxTypes: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    showCurrencyControl: false,
  };

  selectCountryTaxType = countryTaxTypes => {
    const {
      selectCountryTaxType,
      periodName,
      groupType,
      groupItem,
      groupBy,
      statutoryTaxRate,
      detailedCountryTaxTypesData,
    } = this.props;

    selectCountryTaxType({
      statutoryTaxRate,
      countryTaxTypes,
      groupType,
      groupItem,
      groupBy,
      periodName,
      detailedCountryTaxTypesData,
    });
  };

  selectStatutoryTaxRate = statutoryTaxRate => {
    const {
      selectStatutoryTaxRate,
      periodName,
      groupType,
      groupItem,
      groupBy,
      selectedCountryTaxTypes: countryTaxTypes,
      detailedCountryTaxTypesData,
    } = this.props;

    selectStatutoryTaxRate({
      statutoryTaxRate,
      countryTaxTypes,
      groupType,
      groupItem,
      groupBy,
      periodName,
      detailedCountryTaxTypesData,
    });
  };

  onReportingCurrencyChange = () => {
    if (this.props.fetchReport) {
      this.props.fetchReport();
    }
  };

  render() {
    const {
      allCountryTaxTypes,
      selectedCountryTaxTypes,
      allStatutoryTaxRates,
      statutoryTaxRate,
      showCurrencyControl,
      isFetchingCountryTaxTypes,
    } = this.props;

    return (
      <div>
        {showCurrencyControl
          ? (
            <div className="form-control-row">
              <span>Reporting currency</span>
              <ReportingCurrencySelect
                onChange={this.onReportingCurrencyChange}
              />
            </div>
          )
          : null}
        <div className="form-control-row">
          <span>Statutory tax rate to reconcile to</span>
          <Select
            className="form-control str-select"
            clearable={false}
            options={allStatutoryTaxRates}
            value={statutoryTaxRate}
            onChange={this.selectStatutoryTaxRate}
            labelKey="label"
            disabled={isFetchingCountryTaxTypes}
          />
        </div>
        <div className="form-control-row">
          <span className="ctt-label">Select one or more country tax types</span>
          <TruncatableSelect
            className="ctt-select-wrapper"
            selectComponentClassName="form-control ctt-select"
            multi
            options={allCountryTaxTypes}
            value={selectedCountryTaxTypes}
            onChange={this.selectCountryTaxType}
            virtualized
            autosize
            removeSelected
            autoSelectAllValues
            disabled={isFetchingCountryTaxTypes}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    detailedCountryTaxTypesData: detailedCountryTaxTypesDataSelector(state),
    isFetchingCountryTaxTypes: isFetchingCountryTaxTypesSelector(state),
  };
}

export default connect(
  mapStateToProps
)(EffectiveTaxRateForm);
